import { Box } from '@mui/material';
import { useDocumentContext } from '../DocumentContext';
import BookDetails from './BookDetails';
import Loading from './Loading';
import LoadingError from './LoadingError';

export default function BookDetailsMenu() {
  const { state, productMeta } = useDocumentContext();

  return (
    <Box aria-live='polite' sx={{ width: '100%' }}>
      {state === 'loading' && <Loading />}
      {state === 'error' && <LoadingError />}
      {state === 'ready' && productMeta && (
        <BookDetails productMeta={productMeta} />
      )}
    </Box>
  );
}
